/*
 *
 * EditCompanyPopup
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 02-Apr-2025
 */

import React from 'react'
import PropTypes from 'prop-types'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useIntl } from 'react-intl'
import formattedMessage from './languageModule'
import Toggle from 'Hoc/ToggleComponent'
import MerchantGenericCard from '@nexidigital/merchantgenericcard'
import MerchantModal from '@nexidigital/merchantmodal'
import PortalTextInput from '@nexidigital/portaltextinput'
import { nullSafe } from 'Utility/globalMethods'
import './EditCompanyPopup.scss'
import { capitalizeAllString } from 'Utility/utils'

const EditCompanyPopup = (props) => {
  const intl = useIntl()

  const handleCloseModal = () => {
    formik.resetForm({ values: { [SHOP_ALIAS]: '' } })
    props.actions.doHidePopup()
  }

  const SHOP_ALIAS = 'shopAlias'

  const initialValues = {
    [SHOP_ALIAS]: nullSafe(() => (props.shopDetail.alias ? props.shopDetail.alias : capitalizeAllString(props.shopDetail.name)), '')
  }

  const validationMessages = {
    required: intl.formatMessage(formattedMessage.requiredError.props)
  }

  const validationSchema = Yup.object().shape({
    [SHOP_ALIAS]: Yup.string().required(validationMessages.required)
  })

  const handleSubmit = (values) => {
    const formattedValues = {
      alias: values.shopAlias,
      shopCode: props.shopDetail.shopCode,
      shopId: props.shopDetail.shopId
    }
    props.actions.doEditShopAlias(formattedValues)
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: handleSubmit
  })

  return (
    <Toggle>
      <MerchantModal
        topBarTitle={formattedMessage.modalCustomName}
        customAnalyticsDescription={formattedMessage.modalEditNameSubtitle}
        onClose={handleCloseModal}
        primaryAction={() => {
          formik.handleSubmit()
        }}
        primaryButtonLabel={formattedMessage.confirm}
        secondaryAction={handleCloseModal}
        secondaryButtonLabel={formattedMessage.cancel}
        primaryButtonLoading={props.isEditShopLoading}
      >
        <div>{formattedMessage.modalEditNameSubtitle}</div>
        <MerchantGenericCard
          empty
        >
          <PortalTextInput
            id={SHOP_ALIAS}
            name={SHOP_ALIAS}
            labelTooltip={formattedMessage.modalEditShopAlias}
            helperText=''
            label={intl.formatMessage({ id: 't.app.companydata.detail.shop.alias' })}
            labelIcon='info'
            error={formik.touched[SHOP_ALIAS] && formik.errors[SHOP_ALIAS]}
            errorText={formik.errors[SHOP_ALIAS]}
            {...formik.getFieldProps(SHOP_ALIAS)}
            placementTooltip='top'
            variantTooltip='withoutArrow'
            placeholderBlank
          />
        </MerchantGenericCard>
      </MerchantModal>
    </Toggle>
  )
}

EditCompanyPopup.propTypes = {
  actions: PropTypes.object,
  shopDetail: PropTypes.object,
  isEditShopLoading: PropTypes.bool
}

EditCompanyPopup.defaultProps = {
  actions: {},
  shopDetail: {},
  isEditShopLoading: false
}

export default EditCompanyPopup
